<div class="container-fluid">
  <div class="row justify-content-center bg-fondo">
    <div class="col-sm-6 col-md-3 col-lg-3 bloque">
      <fa-icon [icon]="['fas', 'phone']"></fa-icon>
      <div class="division">
        <div class="text1">3 76 91 20</div>
        <div class="text2">Bogotá</div>
      </div>
    </div>
    <div class="col-sm-6 col-md-3 col-lg-3 bloque">
      <fa-icon [icon]="['fas', 'phone']"></fa-icon>
      <div class="division">
        <div class="text1">018000910747</div>
        <div class="text2">Línea gratuita nacional</div>
      </div>
    </div>
    <div class="col-sm-6 col-md-3 col-lg-3 bloque">
      <fa-icon [icon]="['fas', 'globe']"></fa-icon>
      <div class="division">
        <div class="text1">Carrera 7 # 75-26</div>
        <div class="text2">Bogotá, Colombia</div>
      </div>
    </div>
    <div class="col-sm-6 col-md-3 col-lg-3 bloque align-self-center">
      <fa-icon></fa-icon>
      <div style="margin-top: .75rem;">
        <div class="text1">www.chevyplan.com.co</div>
        <div class="text2"></div>
      </div>
    </div>
  </div>
  <div class="row justify-content-center bg-fondo1 text-light py-1">
    <div class="col-lg-12 text-center">Derechos reservados - ChevyPlan S.A. - Bogotá, Colombia 2020</div>
  </div>
</div>
